import { combineReducers } from 'redux';

import hydrateReducer from './hydrateReducer';

import addonsReducer from './entities/addons/reducer';
import adminAdditionalInstructionTranslationsReducer from './entities/adminAdditionalInstructionTranslations/reducer';
import adminAddonsReducer from './entities/adminAddons/reducer';
import adminAttendeesReducer from './entities/adminAttendees/reducer';
import adminDonationTranslationsReducer from './entities/adminDonationTranslations/reducer';
import adminDonationsReducer from './entities/adminDonations/reducer';
import adminEventAdditionalInstructionsReducer from './entities/adminEventAdditionalInstructions/reducer';
import adminEventStatisticsReducer from './entities/adminEventStatistics/reducer';
import adminEventImageTranslationsReducer from './entities/adminEventImageTranslations/reducer';
import adminEventImagesReducer from './entities/adminEventImages/reducer';
import adminEventSponsorsReducer from './entities/adminEventSponsors/reducer';
import adminEventMetaTagsReducer from './entities/adminEventMetaTags/reducer';
import adminEventOrganizationMentionsReducer from './entities/adminEventOrganizationMentions/reducer';
import adminEventRegistrantsEmailsReducer from './entities/adminEventRegistrantsEmails/reducer';
import adminEventRemindersReducer from './entities/adminEventReminders/reducer';
import adminEventSettingsReducer from './entities/adminEventSettings/reducer';
import adminEventTranslationsReducer from './entities/adminEventTranslations/reducer';
import adminEventVideosReducer from './entities/adminEventVideos/reducer';
import adminEventsReducer from './entities/adminEvents/reducer';
import adminOrdersReducer from './entities/adminOrders/reducer';
import adminOrganizationStatisticsReducer from './entities/adminOrganizationStatistics/reducer';
import adminOrganizationImageTranslationReducer from './entities/adminOrganizationImagesTranslation/reducer';
import adminOrganizationImagesReducer from './entities/adminOrganizationImages/reducer';
import adminOrganizationsMetaTagsReducer from './entities/adminOrganizationMetatags/reducer';
import adminOrganizationReportsReducer from './entities/adminOrganizationReports/reducer';
import adminOrganizationTranslationReducer from './entities/adminOrganizationTranslation/reducer';
import adminOrganizationTypesReducer from './entities/adminOrganizationTypes/reducer';
import adminOrganizationVideosReducer from './entities/adminOrganizationVideos/reducer';
import adminOrganizationsAutoCompleteReducer from './entities/adminOrganizationsAutoComplete/reducer';
import adminOrganizationsParentAutoCompleteReducer from './entities/adminOrganizationsParentAutoComplete/reducer';
import adminOrganizationsReducer from './entities/adminOrganizations/reducer';
import adminPlatformUsersReducer from './entities/adminPlatformUsers/reducer';
import adminQuestionsReducer from './entities/adminQuestions/reducer';
import adminTicketsReducer from './entities/adminTickets/reducer';
import adminUsersReducer from './entities/adminUsers/reducer';
import adminZoomEventsReducer from './entities/adminZoomEvents/reducer';
import adminMarketsReducer from './entities/adminMarkets/reducer';
import marketsReducer from './entities/markets/reducer';
import calendarSettingsReducer from './entities/calendarSettings/reducer';
import countriesReducer from './entities/countries/reducer';
import defaultMetaTagsReducer from './entities/defaultMetaTags/reducer';
import donationsReducer from './entities/donations/reducer';
import eventCategoriesReducer from './entities/eventCategories/reducer';
import eventEmailSubscriptionReducer from './entities/eventEmailSubscription/reducer';
import eventTargetAgesReducer from './entities/eventTargetAges/reducer';
import eventsReducer from './entities/events/reducer';
import notCompletedOrdersReducer from './entities/notCompletedOrders/reducer';
import optionsReducer from './entities/options/reducer';
import ordersReducer from './entities/orders/reducer';
import organizationsReducer from './entities/organizations/reducer';
import paymentMethodsReducer from './entities/paymentMethods/reducer';
import tagsReducer from './entities/tags/reducer';
import ticketsReducer from './entities/tickets/reducer';
import userMfaReducer from './entities/userMfa/reducer';
import usersReducer from './entities/users/reducer';
import adminPromoCodesReducer from './entities/adminPromoCodes/reducer';
import adminOrganizationChannelsReducer from './entities/adminOrganizationChannels/reducer';
import adminTrustProfilesReducer from './entities/adminTrustProfiles/reducer';
import adminOrganizationSpecialHostsReducer from './entities/adminOrganizationSpecialHosts/reducer';
import adminOrgSpecialHostEventsReducer from './entities/adminOrgSpecialHostEvents/reducer';
import adminSpecialHostRolesReducer from './entities/adminSpecialHostRoles/reducer';
import adminEventHostsReducer from './entities/adminEventHosts/reducer';
import eventHostReducer from './entities/eventHosts/reducer';
import specialHostsReducer from './entities/specialHosts/reducer';
import adminParentOrgReducer from './entities/adminParentOrg/reducer';
import adminMarketNeighborhoodsReducer from './entities/adminMarketNeighborhoods/reducer';
import adminOrganizationSettingsTranslationReducer from './entities/adminOrganizationSettingsTranslation/reducer';
import adminEventSessionsTranslationsReducer from './entities/adminEventSessionsTranslations/reducer';

import adminPermissionReducer from './features/adminPermission/reducer';
import analyticsReducer from './features/analytics/reducer';
import authReducer from './features/auth/reducer';
import creatingOrderReducer from './features/creatingOrder/reducer';
import deeplinkReducer from './features/deeplink/reducer';
import eventDraftReducer from './features/eventDraft/reducer';
import detectMarketReducer from './features/detectMarket/reducer';
import zoomReducer from './features/zoom/reducer';
import recaptchaReducer from './features/reCaptcha/reducer';
import accountReducer from './features/account/reducer';

import notificationsReducer from './ui/notifications/reducer';
import getOrgTypesReducer from './entities/orgTypes/reducer';
import channelsReducer from './entities/channels/reducer';
import surveysReducer from './entities/surveys/reducer';

const combinedReducer = combineReducers({
  entities: combineReducers({
    addons: addonsReducer,
    adminAdditionalInstructionTranslations: adminAdditionalInstructionTranslationsReducer,
    adminAddons: adminAddonsReducer,
    adminAttendees: adminAttendeesReducer,
    adminDonationTranslations: adminDonationTranslationsReducer,
    adminDonations: adminDonationsReducer,
    adminEventAdditionalInstructions: adminEventAdditionalInstructionsReducer,
    adminEventStatistics: adminEventStatisticsReducer,
    adminEventImageTranslations: adminEventImageTranslationsReducer,
    adminEventImages: adminEventImagesReducer,
    adminEventSponsors: adminEventSponsorsReducer,
    adminEventMetaTags: adminEventMetaTagsReducer,
    adminEventOrganizationMentions: adminEventOrganizationMentionsReducer,
    adminEventRegistrantsEmails: adminEventRegistrantsEmailsReducer,
    adminEventReminders: adminEventRemindersReducer,
    adminEventSettings: adminEventSettingsReducer,
    adminEventTranslations: adminEventTranslationsReducer,
    adminEventVideos: adminEventVideosReducer,
    adminEvents: adminEventsReducer,
    adminOrders: adminOrdersReducer,
    adminOrganizationStatistics: adminOrganizationStatisticsReducer,
    adminOrganizationImageTranslation: adminOrganizationImageTranslationReducer,
    adminOrganizationImages: adminOrganizationImagesReducer,
    adminOrganizationMetaTags: adminOrganizationsMetaTagsReducer,
    adminOrganizationReports: adminOrganizationReportsReducer,
    adminOrganizationTranslation: adminOrganizationTranslationReducer,
    adminOrganizationTypes: adminOrganizationTypesReducer,
    adminOrganizationVideos: adminOrganizationVideosReducer,
    adminOrganizations: adminOrganizationsReducer,
    adminOrganizationsAutoComplete: adminOrganizationsAutoCompleteReducer,
    adminOrganizationsParentAutoComplete: adminOrganizationsParentAutoCompleteReducer,
    adminPlatformUsers: adminPlatformUsersReducer,
    adminQuestions: adminQuestionsReducer,
    adminTickets: adminTicketsReducer,
    adminUsers: adminUsersReducer,
    adminZoomEvents: adminZoomEventsReducer,
    adminPromoCodes: adminPromoCodesReducer,
    adminOrganizationChannels: adminOrganizationChannelsReducer,
    adminMarkets: adminMarketsReducer,
    adminOrganizationSettingsTranslation: adminOrganizationSettingsTranslationReducer,
    channels: channelsReducer,
    markets: marketsReducer,
    calendarSettings: calendarSettingsReducer,
    countries: countriesReducer,
    donations: donationsReducer,
    defaultMetaTags: defaultMetaTagsReducer,
    eventCategories: eventCategoriesReducer,
    eventEmailSubscription: eventEmailSubscriptionReducer,
    eventTargetAges: eventTargetAgesReducer,
    events: eventsReducer,
    notCompletedOrders: notCompletedOrdersReducer,
    options: optionsReducer,
    orders: ordersReducer,
    organizations: organizationsReducer,
    orgTypes: getOrgTypesReducer,
    paymentMethods: paymentMethodsReducer,
    tags: tagsReducer,
    tickets: ticketsReducer,
    users: usersReducer,
    mfa: userMfaReducer,
    adminEventSessionsTranslations: adminEventSessionsTranslationsReducer,
    adminTrustProfiles: adminTrustProfilesReducer,
    adminOrganizationSpecialHosts: adminOrganizationSpecialHostsReducer,
    adminOrganizationSpecialHostEvents: adminOrgSpecialHostEventsReducer,
    adminSpecialHostRoles: adminSpecialHostRolesReducer,
    adminEventHosts: adminEventHostsReducer,
    eventHosts: eventHostReducer,
    specialHosts: specialHostsReducer,
    adminParentOrg: adminParentOrgReducer,
    adminMarketNeighborhoods: adminMarketNeighborhoodsReducer,
    surveys: surveysReducer,
  }),
  features: combineReducers({
    adminPermission: adminPermissionReducer,
    analytics: analyticsReducer,
    auth: authReducer,
    creatingOrder: creatingOrderReducer,
    deeplink: deeplinkReducer,
    eventDraft: eventDraftReducer,
    detectMarket: detectMarketReducer,
    zoom: zoomReducer,
    reCaptcha: recaptchaReducer,
    account: accountReducer,
  }),
  ui: combineReducers({
    notifications: notificationsReducer,
  }),
});

export type RootState = ReturnType<typeof combinedReducer>;

export default function rootReducer(state: any, action: any) {
  return combinedReducer(hydrateReducer(state, action), action);
}
